<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99992 13.3333C8.36811 13.3333 8.66659 13.0349 8.66659 12.6667C8.66659 12.2985 8.36811 12 7.99992 12C7.63173 12 7.33325 12.2985 7.33325 12.6667C7.33325 13.0349 7.63173 13.3333 7.99992 13.3333Z"
      stroke="#6C6D84"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.99992 8.66671C8.36811 8.66671 8.66659 8.36823 8.66659 8.00004C8.66659 7.63185 8.36811 7.33337 7.99992 7.33337C7.63173 7.33337 7.33325 7.63185 7.33325 8.00004C7.33325 8.36823 7.63173 8.66671 7.99992 8.66671Z"
      stroke="#6C6D84"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.99992 3.99996C8.36811 3.99996 8.66659 3.70148 8.66659 3.33329C8.66659 2.9651 8.36811 2.66663 7.99992 2.66663C7.63173 2.66663 7.33325 2.9651 7.33325 3.33329C7.33325 3.70148 7.63173 3.99996 7.99992 3.99996Z"
      stroke="#6C6D84"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
